// extracted by mini-css-extract-plugin
module.exports = {"skeletonSubtitle":"SkeletonSubtitle_skeletonSubtitle__3WtJs"};